import { SvgIconProps } from "@mui/material/SvgIcon";

interface BoldIconProps extends SvgIconProps {
    strokeWidth?: number;
}

const BoldIcon: React.FC<BoldIconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width={props.strokeWidth || 1.5}
      stroke-linecap="round"
      stroke-linejoin="round"
      className="lucide lucide-bold-icon lucide-bold"
      {...props}
    >
      <path d="M6 12h9a4 4 0 0 1 0 8H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h7a4 4 0 0 1 0 8" />
    </svg>
  );
};

export default BoldIcon;
